export const PREPROD_DSS_LOGIN_FAILURE_URL =
  'https://ciam-test.sd.demo.truelink.com/realms/TransUnion/protocol/openid-connect/auth?response_type=code&redirect_uri=https://members-preprod.transunion.com/sso-login&client_id=Phoenix&scope=openid';
export const PROD_DSS_LOGIN_FAILURE_URL =
  'https://ciam.tui.transunion.com/realms/TransUnion/protocol/openid-connect/auth?response_type=code&redirect_uri=https://members.transunion.com/sso-login&client_id=Phoenix&scope=openid';
